import React, {useEffect, useState} from 'react';
import {
	Card,
	CardHeader,
	CardContent,
	Grid,
	TextField,
	Button,
	IconButton,
	Tooltip,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	LinearProgress, Typography, CardActions,
	Chip,
	Snackbar,
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import {makeStyles} from '@material-ui/core/styles';
import LaunchIcon from '@material-ui/icons/Launch';
import SaveIcon from '@material-ui/icons/Save';
import moment from 'moment';
import AddIcon from "@material-ui/icons/Add";
import CardGiftcardIcon from "@material-ui/icons/CardGiftcard";
import EditIcon from "@material-ui/icons/Edit";
import Box from "@material-ui/core/Box";
import DeleteIcon from "@material-ui/icons/Delete";
import AssignmentOutlined from "@material-ui/icons/AssignmentOutlined";
import CheckCircle from "@material-ui/icons/CheckCircle";
import Schedule from "@material-ui/icons/Schedule";

const useStyles = makeStyles((theme) => ({
	card: {
		marginBottom: theme.spacing(3),
	},
	table: {
		minWidth: 650,
		'& .MuiTableCell-root': {
			borderBottom: 'none',
			padding: theme.spacing(1.5),
		},
		'& .MuiTableRow-root': {
			'&:hover': {
				backgroundColor: theme.palette.action.hover,
			},
		},
	},
	link: {
		cursor: 'pointer',
		display: 'flex',
		alignItems: 'center',
		textDecoration: 'none',
		color: theme.palette.primary.main,
		marginLeft: theme.spacing(1),
	},
	button: {
		backgroundColor: theme.palette.primary.main,
		color: theme.palette.common.white,
		'&:hover': {
			backgroundColor: theme.palette.primary.dark,
		},
	},
	progress: {
		backgroundColor: theme.palette.grey[500],
	},
	addPaymentBtn: {
		color: theme.palette.primary.main,
		margin: theme.spacing(1),
	}
}));

const OrderPaymentTable = ({
	                           details,
	                           dialogLoading = false,
	                           onAddPaymentClick,
	                           onDeliPointsClick,
	                           paymentModalType,
	                           setDeletePaymentModal,
	                           setPaymentNoteId,
	                           orderPayment,
	                           paymentNoteMethod,
	                           calculatePaymentNote,
	                           calculateRemainingPayment,
	                           calculateTotalToPayPayment,
	                           calculateDeliveryFee,
	                           calculateCouponDiscount,
	                           calculateItemsTotal,
	                           orderSummery,
	                           driverTip,
	                           onDriverTipChange,
	                           calculatedTotals,
	                           deliveryFee,
	                           orderCouponDiscount,
                           }) => {
	const classes = useStyles();
	
	// Copy notification state
	const [copyNotification, setCopyNotification] = useState({ open: false, message: '' });
	
	// Handle copy with notification
	const handleCopy = (text, label) => {
		if (navigator?.clipboard) {
			navigator.clipboard.writeText(text);
		}
		setCopyNotification({ open: true, message: `${label} copied!` });
	};
	
	// Close copy notification
	const handleCloseCopyNotification = () => {
		setCopyNotification({ open: false, message: '' });
	};
	// Use calculatedTotals if available (from recalculate), otherwise use orderSummery (from saved data)
	// Priority: calculatedTotals (from recalculate) > orderSummery (from saved/loaded data)
	const apiItemTotal = calculatedTotals?.item_total ?? orderSummery.item_total ?? 0;
	const apiDeliveryFee = calculatedTotals?.delivery_fee ?? orderSummery.delivery_fee ?? 0;
	// For coupon discount: use calculatedTotals only if it's > 0, otherwise use orderSummery
	const apiCouponDiscount = (calculatedTotals?.coupon_discount_amount && calculatedTotals.coupon_discount_amount > 0)
		? calculatedTotals.coupon_discount_amount
		: (calculatedTotals?.coupon_discount_amount === 0 ? 0 : (orderSummery.coupon_discount_amount || 0));

	// Total to Pay = Item Total + Delivery Fee - Coupon Discount
	// (Coupon is already applied/deducted, matches backend calculation)
	// Backend: payment_amount = item_total + delivery_fee - coupon_discount
	const apiTotalToPay = Math.round((apiItemTotal + apiDeliveryFee - apiCouponDiscount) * 100) / 100;

	// Paid = Already Paid (just actual payments made)
	const apiTotalPaid = Math.round((orderSummery.already_paid_amount || 0) * 100) / 100;

	// Driver Tip
	const apiDriverTip = Math.round((orderSummery.driver_tip || 0) * 100) / 100;

	// Remaining = Total to Pay + Driver Tip - Paid (rounded to 2 decimals)
	const apiRemainingAmount = Math.round((apiTotalToPay + apiDriverTip - apiTotalPaid) * 100) / 100;

	// Color for "Total to Pay" - always green/neutral
	const totalToPayColor = "#2e7d32";

	// Color for "Remaining" - red if negative (overpaid), green if positive (underpaid)
	/*
	// Color for "Remaining" - red if negative (overpaid), green if positive (underpaid)
	const remainingColor = apiRemainingAmount < 0 ? "#d32f2f" : "#2e7d32";

	const handleDeletePayment = (paymentId) => {
		setDeletePaymentModal(true)
		setPaymentNoteId(paymentId)
	}
	*/
	// Color for "Remaining" - red if negative (overpaid), green if positive (underpaid)
	const remainingColor = apiRemainingAmount < 0 ? "#d32f2f" : "#2e7d32";

	const handleDeletePayment = (paymentId) => {
		setDeletePaymentModal(true)
		setPaymentNoteId(paymentId)
	}
	return (
		<>
		<Grid container spacing={2} className={"mt-2"}>
			{/* Payment List */}
			<Grid item xs={12}>
				<Card className={classes.card}>
					<CardHeader
						title={
							<Typography variant="h6" component="div" fontWeight="bold">
								PAYMENTS
							</Typography>
						}
						className={classes.cardHeader}
					/>

					{dialogLoading && <LinearProgress className={classes.progress}/>}

					<CardContent>

						<>
							{details.order_payment_noteds?.length > 0 ? (
								<TableContainer>
									<Table className={classes.table} aria-label="payment table" size="small">
										<TableHead>
											<TableRow>
												<TableCell align="left">Date</TableCell>
												<TableCell align="right">Amount</TableCell>
												<TableCell align="left">Method</TableCell>
												<TableCell align="left">Payment Detail</TableCell>
												<TableCell align="left">Reason</TableCell>
												<TableCell align="left">Comment</TableCell>
												<TableCell align="left">Action</TableCell>
											</TableRow>
										</TableHead>
										<TableBody>
											{details.order_payment_noteds.map((payment, idx) => (
												<TableRow
													key={payment.id}
													hover // Adds hover effect
													style={{cursor: "pointer"}} // Shows pointer on hover
												>
													{/* Date */}
													<TableCell align="left">
														<Typography noWrap>
															{moment(payment.date).format("YYYY-MM-DD")}
														</Typography>
													</TableCell>

													<TableCell align="right">
														{payment.amount ? (
															<Typography
																variant="body1"
																style={{
																	color: [paymentNoteMethod.ONLINE, paymentNoteMethod.PAYMENT_LINK].includes(payment.payment_type) && payment.is_paid === 0
																		? "#ff9800" // Yellow for unpaid Payment Link
																		: payment.type === "refund"
																			? "#d32f2f" // Red for refund
																			: "#2e7d32", // Green for payment
																	fontWeight: 500,
																}}
															>
																{payment.type === "refund"
																	? `-${payment.amount.toFixed(2)}`
																	: payment.amount.toFixed(2)}
															</Typography>
														) : "-"}
													</TableCell>

													{/* Payment Method (with tooltip if long) */}
													<TableCell align="left">
														<Tooltip title={payment.payment_method || ""} enterDelay={500}>
															<Typography noWrap style={{maxWidth: 120}}>
																{payment.payment_method}
															</Typography>
														</Tooltip>
													</TableCell>

													{/* Payment Detail (with tooltip if long) */}
													<TableCell align="left">
														<div>
															{/* Main payment detail with tooltip */}
															<Tooltip title={payment.payment_detail || ""} enterDelay={500}>
																<Typography noWrap variant="body2">
																	{payment.payment_detail}
																	{
																		(payment.payment_type === paymentNoteMethod.PAYMENT_LINK) ? payment.is_paid === 0 ?
																			<Chip icon={<Schedule />} label="Waiting" size="small" style={{backgroundColor: '#ff9800', color: 'white', marginLeft: 8}} /> :
																			<Chip icon={<CheckCircle />} label="Paid" size="small" style={{backgroundColor: '#9cc54b', color: 'white', marginLeft: 8}} /> : null
																	}
																</Typography>
															</Tooltip>

															{/* Payment Metadata - conditional and inline */}
															{idx === 0 && details.payment_method_name === "Paid online" && (
																<div style={{marginTop: 8}}>
																	{/* Order Reference */}
																	{orderPayment(details).p_txnld && (
																		<div style={{display: "flex", alignItems: "center", marginBottom: 4}}>
																			<Typography variant="caption" color="textSecondary" style={{minWidth: 80}}>
													Order Ref:
												</Typography>
												<Typography variant="body2" className="text-primary" noWrap style={{flexGrow: 1, maxWidth: 120}}>
													{orderPayment(details).p_txnld}
												</Typography>
												<Tooltip title="Copy Order Reference">
													<Button
														size="small"
														variant="text"
														onClick={() => handleCopy(orderPayment(details).p_txnld, 'Order Ref')}
														style={{marginLeft: 8}}
													>
														<AssignmentOutlined fontSize="small"/>
													</Button>
												</Tooltip>
																		</div>
																	)}

																	{/* Bank Payment Reference */}
																	<div style={{display: "flex", alignItems: "center", marginBottom: 4}}>
																		<Typography variant="caption" color="textSecondary">
																			Bank Ref:
																		</Typography>
																		<Typography variant="body2" className="text-primary" noWrap style={{flexGrow: 1}}>
																			{orderPayment(details).payment_reference || "null"}
																		</Typography>
																		<Button
																			size="small"
																			variant="text"
																			onClick={() => navigator?.clipboard?.writeText(orderPayment(details).payment_reference)}
																			style={{marginLeft: 8}}
																		>
																			<AssignmentOutlined fontSize="small"/>
																		</Button>
																	</div>

																	{/* Payment Token */}
																	{orderPayment(details).p_token && (
																		<div style={{display: "flex", alignItems: "center"}}>
																			<Typography variant="caption" color="textSecondary" style={{minWidth: 130}}>
																				Payment Token:
																			</Typography>
																			<Typography variant="body2" className="text-primary" noWrap style={{flexGrow: 1}}>
																				{orderPayment(details).p_token}
																			</Typography>
																			<Button
																				size="small"
																				variant="text"
																				onClick={() => navigator?.clipboard?.writeText(orderPayment(details).p_token)}
																				style={{marginLeft: 8}}
																			>
																				<AssignmentOutlined fontSize="small"/>
																			</Button>
																		</div>
																	)}
																</div>
															)}
															{payment.payment_type === paymentNoteMethod.PAYMENT_LINK && (
																<div style={{marginTop: 8}}>
                                                                    {/* Payment Link URL (if exists) */}
                                                                    {payment.payment_link && (
                                                                        <div style={{display: "flex", alignItems: "center", marginBottom: 4, maxWidth: 150}}>
                                                                            <Typography variant="body2" className="text-primary" noWrap style={{flexGrow: 1}}>
                                                                                {payment.payment_link}
                                                                            </Typography>
                                                                            <Button
                                                                                size="small"
                                                                                variant="text"
                                                                                onClick={() => navigator?.clipboard?.writeText(payment.payment_link)}
                                                                                style={{marginLeft: 8}}
                                                                            >
                                                                                <AssignmentOutlined fontSize="small"/>
                                                                            </Button>
                                                                        </div>
                                                                    )}

                                                                    {/* Order Reference */}
                                                                    {payment.p_txnld && (
                                                                        <div style={{display: "flex", alignItems: "center", marginBottom: 4}}>
                                                                            <Typography variant="caption" color="textSecondary" style={{minWidth: 80}}>
                                                                                Order Ref:
                                                                            </Typography>
                                                                            <Typography variant="body2" className="text-primary" noWrap style={{flexGrow: 1, maxWidth: 120}}>
                                                                                {payment.p_txnld}
                                                                            </Typography>
                                                                            <Button
                                                                                size="small"
                                                                                variant="text"
                                                                                onClick={() => navigator?.clipboard?.writeText(payment.p_txnld)}
                                                                                style={{marginLeft: 4, padding: 0, minWidth: 30}}
                                                                            >
                                                                                <AssignmentOutlined style={{fontSize: 16}}/>
                                                                            </Button>
                                                                        </div>
                                                                    )}

                                                                    {/* Bank Ref */}
                                                                    {payment.payment_reference && (
                                                                        <div style={{display: "flex", alignItems: "center", marginBottom: 4}}>
                                                                            <Typography variant="caption" color="textSecondary" style={{minWidth: 80}}>
                                                                                Bank Ref:
                                                                            </Typography>
                                                                            <Typography variant="body2" className="text-primary" noWrap style={{flexGrow: 1, maxWidth: 120}}>
                                                                                {payment.payment_reference}
                                                                            </Typography>
                                                                            <Button
                                                                                size="small"
                                                                                variant="text"
                                                                                onClick={() => navigator?.clipboard?.writeText(payment.payment_reference)}
                                                                                style={{marginLeft: 4, padding: 0, minWidth: 30}}
                                                                            >
                                                                                <AssignmentOutlined style={{fontSize: 16}}/>
                                                                            </Button>
                                                                        </div>
                                                                    )}

                                                                     {/* Payment Token */}
                                                                    {payment.p_token && (
                                                                        <div style={{display: "flex", alignItems: "center"}}>
                                                                            <Typography variant="caption" color="textSecondary" style={{minWidth: 80}}>
                                                                                Token:
                                                                            </Typography>
                                                                            <Typography variant="body2" className="text-primary" noWrap style={{flexGrow: 1, maxWidth: 120}}>
                                                                                {payment.p_token}
                                                                            </Typography>
                                                                            <Button
                                                                                size="small"
                                                                                variant="text"
                                                                                onClick={() => navigator?.clipboard?.writeText(payment.p_token)}
                                                                                style={{marginLeft: 4, padding: 0, minWidth: 30}}
                                                                            >
                                                                                <AssignmentOutlined style={{fontSize: 16}}/>
                                                                            </Button>
                                                                        </div>
                                                                    )}
																</div>
															)}
														</div>
													</TableCell>

													{/* Reason (with tooltip if long) */}
													<TableCell align="left">
														<Tooltip title={payment.reason || ""} enterDelay={500}>
															<Typography noWrap style={{maxWidth: 150}}>
																{payment.reason || "-"}
															</Typography>
														</Tooltip>
													</TableCell>

													{/* Comment (with tooltip if long) */}
													<TableCell align="left" style={{maxWidth: 150, overflow: 'hidden'}}>
														<Tooltip
															title={payment.comment || "No comment"}
															enterDelay={300}
															disableHoverListener={!payment.comment || payment.comment.length <= 20}
														>
															<Typography noWrap variant="body2">
																{payment.comment || "-"}
															</Typography>
														</Tooltip>
													</TableCell>

													{/* Edit Button (only visible if allowed & on hover) */}
													<TableCell align="left" style={{width: 120}}>
														{payment.allow_edit === 1 && (
															<div style={{
																display: 'flex',
																gap: 8,
																opacity: 0.7,
																'&:hover': {opacity: 1}
															}}>
																{/* Edit Button */}
																<Tooltip title="Edit" enterDelay={300}>
																	<IconButton
																		onClick={(e) => {
																			e.stopPropagation();
																			onAddPaymentClick("edit", payment);
																		}}
																		size="small"
																		color="primary"
																	>
																		<EditIcon fontSize="small"/>
																	</IconButton>
																</Tooltip>

																{/* Delete Button */}
																<Tooltip title="Delete" enterDelay={300}>
																	<IconButton
																		onClick={(e) => {
																			e.stopPropagation();
																			handleDeletePayment(payment.id)
																		}}
																		size="small"
																		color="secondary"
																	>
																		<DeleteIcon fontSize="small"/>
																	</IconButton>
																</Tooltip>
															</div>
														)}
													</TableCell>
												</TableRow>
											))}
										</TableBody>
									</Table>
								</TableContainer>
							) : (
								<>
									<Typography variant="body2" color="textSecondary">
										No payments recorded yet.
									</Typography>
								</>
							)}
							<Grid container className={classes.actionArea}>
								<Button
									variant="text"
									translate={"yes"}
									size="medium"
									startIcon={<AddIcon color={"primary"}/>}
									className={classes.addPaymentBtn}
									onClick={() => onAddPaymentClick("add")}
								>
									Add Payment
								</Button>
							</Grid>
							<Grid container className={classes.actionArea}>
								<Button
									variant="text"
									translate={"yes"}
									size="medium"
									startIcon={<CardGiftcardIcon color="primary"/>}
									className={classes.addPaymentBtn}
									onClick={() => onDeliPointsClick("add")}
								>
									Edit DeliPoints
								</Button>
							</Grid>
							<Grid container spacing={3} justify="flex-end" className={classes.totalSummary}>
									{/* Driver Tip */}
								<Grid item>
									<Box textAlign="right">
										<Typography variant="body2" color="textSecondary" style={{marginBottom: 4}}>
											Driver tip:
										</Typography>
										<TextField
											type="number"
											size="small"
											value={driverTip || 0}
											onChange={(e) => onDriverTipChange(parseFloat(e.target.value) || 0)}
											inputProps={{min: 0, step: 0.01, style: {textAlign: 'right'}}}
											style={{width: 100}}
											InputProps={{
												startAdornment: <Typography style={{marginRight: 4}}>$</Typography>,
											}}
										/>
									</Box>
								</Grid>
								<Grid item>
									<Box textAlign="right">
										<Typography variant="body2" color="textSecondary">
											Total to Pay:
										</Typography>
										<Typography variant="h6" style={{color: totalToPayColor, fontWeight: 600}}>
											${apiTotalToPay.toFixed(2)}
										</Typography>
									</Box>
								</Grid>

								{/* {dpDiscount > 0 && (
									<Grid item>
										<Box textAlign="right">
											<Typography variant="body2" color="textSecondary">
												DeliPoints Redemption:
											</Typography>
											<Typography variant="h6" style={{color: '#d32f2f', fontWeight: 600}}>
												-${dpDiscount.toFixed(2)}
											</Typography>
										</Box>
									</Grid>
								)} */}

								<Grid item>
									<Box textAlign="right">
										<Typography variant="body2" color="textSecondary">
											Paid:
										</Typography>
										<Typography variant="h6" style={{color: "#1565c0", fontWeight: 600}}>
											${apiTotalPaid.toFixed(2)}
										</Typography>
									</Box>
								</Grid>
								<Grid item>
									<Box textAlign="right">
										<Typography variant="body2" color="textSecondary">
											Remaining:
										</Typography>
										<Typography variant="h6" style={{color: remainingColor, fontWeight: 600}}>
											{Math.abs(apiRemainingAmount) < 0.01
												? "0.00"
												: (apiRemainingAmount < 0
													? `-$${Math.abs(apiRemainingAmount).toFixed(2)}`
													: `$${apiRemainingAmount.toFixed(2)}`)}
										</Typography>
									</Box>
								</Grid>
							</Grid>
						</>
					</CardContent>
				</Card>
			</Grid>
		</Grid>

		{/* Copy success notification */}
		<Snackbar
			open={copyNotification.open}
			autoHideDuration={2000}
			onClose={handleCloseCopyNotification}
			anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
		>
			<Alert onClose={handleCloseCopyNotification} severity="success" variant="filled">
				{copyNotification.message}
			</Alert>
		</Snackbar>
		</>
	);
};

export default OrderPaymentTable;